module.exports = __webpack_public_path__ + "img/Vector2.5307dab2.svg";